module.exports = __webpack_public_path__ + "static/img/calcBack.637a734.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calcBack.jpg
// module id = 2TQw
// module chunks = 2